function postsPreview() {
    const slider = tns({
        container: '.slider-posts-preview',
        items: 2.3,
        slideBy: 1,
        autoplay: false,
        controls: false,
        nav: false,
        mouseDrag: true,
    });
}

function sliderLogos() {
    const sliderEl = document.querySelector('.slider-logos');

    if (sliderEl) {
        const slider = tns({
            container: '.slider-logos',
            items: 2,
            loop: true,
            slideBy: 'page',
            autoplay: true,
            prevButton: false,
            nextButton: false,
            controls: false,
            nav: false,
            autoplayButtonOutput: false,
            mouseDrag: true,
            responsive: {
                320: {
                    items: 2.5,
                    gutter: 30,
                },
                900: {
                    items: 4
                },
                1024: {
                    items: 5
                }
            }
        });
    }
}

function sliderText() {
    const rotatingText = document.querySelector('.rotating-text');

    if (rotatingText) {
        const texts = rotatingText.querySelectorAll('strong');
        const firstText = texts[0];
        const lastText = texts[texts.length - 1];

        setInterval(function () {
            const activeText = rotatingText.querySelector('.rotating-text strong.active');

            activeText.classList.add('leaving');

            setTimeout(function () {
                if (activeText === lastText) {
                    firstText.classList.add('active')
                } else {
                    activeText.nextElementSibling.classList.add('active');
                }
                activeText.classList.remove('active');
                activeText.classList.remove('leaving');

            }, 700);

        }, 4000)
    }
}

function widgetSliderPortfolio() {
    const slidersPortfolio = document.querySelectorAll('.slider-portfolio');

    if (slidersPortfolio.length) {
        for (const slider of slidersPortfolio) {
            const sliderInit = tns({
                container: slider,
                items: 3,
                loop: true,
                slideBy: 'page',
                autoplay: true,
                prevButton: false,
                nextButton: false,
                controls: false,
                nav: true,
                navPosition: 'bottom',
                gutter: 60,
                autoplayButtonOutput: false,
                mouseDrag: true,
                responsive: {
                    320: {
                        items: 1.2,
                        gutter: 30
                    },
                    900: {
                        items: 1.3,
                        gutter: 60
                    },
                    1024: {
                        items: 1.5,
                        gutter: 60
                    },
                    1400: {
                        items: 1.8,
                        gutter: 60
                    },
                    1680: {
                        items: 2.2,
                        gutter: 60
                    }
                }
            });
        }
    }
}

export {postsPreview, sliderLogos, sliderText, widgetSliderPortfolio};
